
export enum PlanLevelEnum {
  Plan1 = "PLAN_1",
  Plan2 = "PLAN_2",
  Plan3 = "PLAN_3",
  Plan4 = "PLAN_4",
}
